<div class="secret-dialog">
  <div mat-dialog-content>
    <div class="content">
      <div>
        <mat-icon class="secret-icon" [svgIcon]="IconNames.ice_pensive" />
      </div>
      <div class="header">Ai, dette nummeret kan vi ikke åpne</div>
      <div class="details">Eieren av telefonnummeret må selv ta kontakt med ice kundeservice for mer informasjon.</div>
    </div>
  </div>
  <div mat-dialog-actions>
    <app-ice-button color="secondary" mat-button matDialogClose testId="secret-number-understood-button">
      Forstått
    </app-ice-button>
  </div>
</div>
